/** TanStack Query key catalogue for the messaging domain. centralised so
 * cache mutations from socket handlers + components agree on the shape.
 *
 * structure: ['conversations', ...] for everything messaging-related so
 * a single invalidate('conversations') nukes the whole tree on logout.
 */

export const CONVERSATIONS_LIST_KEY = ['conversations', 'list'] as const

export const CONVERSATIONS_UNREAD_KEY = [
  'conversations',
  'unread-count'
] as const

export function conversationDetailKey(id: string) {
  return ['conversations', 'detail', id] as const
}

export function conversationMessagesKey(id: string) {
  return ['conversations', 'messages', id] as const
}
